function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from "styled-components";
import { MenuItem, Menu, MenuTitle, MenuTrigger, useMenuState } from "@sprout/list-navigation/dist/Menu";
import { useCallback } from "react";
import { DeleteOutlined, EditOutlined, Link, MoreHoriz } from "sprout-ui-icons";
import { Button } from "sprout-ui-dom/dist/Button";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import { useClipboard } from "sprout-ui-dom/dist/hooks";
import { getIsLargePointerDevice } from "sprout-ui-dom/dist/utils";
import { usePostPageEditor } from "../PostPageEditorContext";
import { usePostPageComment } from "./PostPageCommentContext";
const StyledButton = styled(Button)`
  width: 32px;
  height: 32px;
`;
const PostPageCommentMenu = (props)=>{
    const { comment , parentCommentId  } = props;
    const { owner , id  } = comment;
    const currentUser = useCurrentUser();
    const isCommentOwner = (owner === null || owner === void 0 ? void 0 : owner.id) === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id);
    const { deleteComment  } = usePostPageComment();
    const { dispatch  } = usePostPageEditor();
    const handleEdit = useCallback(()=>{
        dispatch({
            type: "SET_EDITOR",
            payload: {
                editor: "EDIT_COMMENT",
                editorPosition: comment.id,
                variant: getIsLargePointerDevice() ? "desktop" : "mobile"
            }
        });
    }, [
        comment.id,
        dispatch
    ]);
    const { supported , copy  } = useClipboard();
    const handleCopy = useCallback(()=>{
        const { protocol , pathname , host  } = window.location;
        copy(`${protocol}//${host}${pathname}#comment-${id}${parentCommentId ? `-${parentCommentId}` : ""}`);
    }, [
        copy,
        id,
        parentCommentId
    ]);
    const menuState = useMenuState();
    if (!supported && !isCommentOwner) return null;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(MenuTrigger, _objectSpread({}, menuState, {
                children: /*#__PURE__*/ _jsx(StyledButton, {
                    variant: "circle",
                    children: /*#__PURE__*/ _jsx(MoreHoriz, {})
                })
            })),
            /*#__PURE__*/ _jsxs(Menu, _objectSpread({}, menuState, {
                children: [
                    /*#__PURE__*/ _jsx(MenuTitle, {
                        children: "Comment Options"
                    }),
                    supported && /*#__PURE__*/ _jsx(MenuItem, {
                        icon: Link,
                        label: "Copy link",
                        onClick: handleCopy
                    }),
                    isCommentOwner && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(MenuItem, {
                                icon: EditOutlined,
                                label: "Edit",
                                onClick: handleEdit
                            }),
                            /*#__PURE__*/ _jsx(MenuItem, {
                                icon: DeleteOutlined,
                                label: "Delete",
                                onClick: deleteComment
                            })
                        ]
                    })
                ]
            }))
        ]
    });
};
export default PostPageCommentMenu;
